<template>
  <div id="csContainer">
<!--    <button class="headMap" @click="headMap()">加热力图</button>-->
    <div id="heatmap" v-show="isShow"></div>
    <el-button class="headMap" size="small" type="primary" @click="headMap()" >加载热力图</el-button>
<!--    <div id="csContainer"></div>-->
  </div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'headMap',
        data(){
            return{
                isShow: false,
                viewer: null
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            init(){
                let vm = util.getViewer("csContainer");
                this.viewer = vm;
            },
            headMap(){
                let viewer = this.viewer;
                var len = 300;
                var points = [];
                var max = 100;

                //热力图图片大小
                var width = 600;
                var height = 400;

                //点坐标的矩形范围
                var latMin = 28.364807;
                var latMax = 40.251095;
                var lonMin = 94.389228;
                var lonMax = 108.666357;

                //随机创建300个点（经度、纬度、热力值）
                var dataRaw = [];
                for (var i = 0; i < len; i++) {
                    var point = {
                        lat: latMin + Math.random() * (latMax - latMin),
                        lon: lonMin + Math.random() * (lonMax - lonMin),
                        value: Math.floor(Math.random() * 100)
                    };
                    dataRaw.push(point);
                }

                //随机创建300个点（x、y、热力值）
                for (var i = 0; i < len; i++) {
                    var dataItem = dataRaw[i];
                    var point = {
                        x: Math.floor((dataItem.lat - latMin) / (latMax - latMin) * width),
                        y: Math.floor((dataItem.lon - lonMin) / (lonMax - lonMin) * height),
                        value: Math.floor(dataItem.value)
                    };
                    max = Math.max(max, dataItem.value);
                    points.push(point);
                }

                var heatmapInstance = h337.create({
                    container: document.querySelector('#heatmap')
                });

                var data = {
                    max: max,
                    data: points
                };


                heatmapInstance.setData(data);

                var canvas = document.getElementsByClassName('heatmap-canvas');

                viewer.entities.add({
                    name: 'heatmap',
                    rectangle: {
                        coordinates: Cesium.Rectangle.fromDegrees(lonMin, latMin, lonMax, latMax),
                        material: new Cesium.ImageMaterialProperty({
                            image: canvas[0],
                            transparent: true
                        })
                    }
                });

                viewer.flyTo(viewer.entities);
                const h = this.$createElement;
                this.$message({
                    message:  h('p', null, [
                        // h('span', null, '内容可以是 '),
                        h('span', { style: 'color: ' }, '  加载热力图成功')

                    ]),
                    iconClass:'el-icon-circle-check',
                    center: true
                });
            },
        },
        beforeDestroy(){
            if(this.destroy){
                this.destroy.destroy();
            }
            this.viewer = null;
    }
    }
</script>
<style scoped>
  .headMap {
    position: absolute;
    margin-left: 25px;
    margin-top:7px;
    z-index: 999;
  }
  #heatmap{
    width: 500px;
    height: 500px;
  }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
